type DiamondOutlineIconProps = {
  size?: number;
  color?: string;
};

const DiamondOutlineIcon = ({
  size = 14,
  color = "currentColor",
}: DiamondOutlineIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M10.6384 1.54053H3.36162C3.19386 1.54514 3.02954 1.58918 2.88194 1.66909C2.73434 1.749 2.60762 1.86254 2.512 2.00053L0.692814 4.52053C0.557731 4.7115 0.490269 4.94214 0.501134 5.17584C0.511999 5.40955 0.600569 5.63292 0.752787 5.81053L6.21035 12.1005C6.30379 12.221 6.42351 12.3185 6.56037 12.3855C6.69723 12.4526 6.84761 12.4874 7 12.4874C7.15239 12.4874 7.30277 12.4526 7.43963 12.3855C7.57649 12.3185 7.69621 12.221 7.78965 12.1005L13.2472 5.81053C13.3994 5.63292 13.488 5.40955 13.4989 5.17584C13.5097 4.94214 13.4423 4.7115 13.3072 4.52053L11.488 2.00053C11.3924 1.86254 11.2657 1.749 11.1181 1.66909C10.9705 1.58918 10.8061 1.54514 10.6384 1.54053Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.48004 1.53027L4.04004 5.31027L7.00004 12.4602"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.55 1.53027L9.98 5.31027L7 12.4602"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M0.52002 5.31055H13.48"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default DiamondOutlineIcon;
